import * as React from 'react';
import { 
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../../components/common/Modal';

export default function ApiKeyModal(props) {
  const {open, value, handleSave, handleClose} = props;
  const [apiKey, setApiKey] = React.useState(value);

  React.useEffect(() => {
    setApiKey(value)
  }, [value]);

  const handleTitle = (e) => {
    setApiKey(e.target.value)
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>Edit Api Key</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <CTextField
            required
            margin="dense"
            id="api-key"
            name="APIKey"
            label="API Key"
            type="text"
            size="small"
            fullWidth
            variant="outlined"
            value={apiKey}
            onChange={handleTitle}
          />
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={() => handleSave(apiKey)}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}